import {register} from '@shopify/theme-sections';

import initVideo from '../components/video';

register('featured-expert-video', {
  onLoad() {
    const video = this.container.querySelector('video');
    if (video) {
      initVideo(video);
    }
  },
});
